import React from "react";
import UserForm from "./components/UserForm";
import Activation from "./components/Activation";
import ApiTokens from "./components/ApiTokens";
import DeleteAccount from "./components/DeleteAccount";

const Settings = () => {
  return (
      <div className="space-y-4">
        <UserForm/>
        <Activation/>
        <ApiTokens/>
        <DeleteAccount/>
      </div>
  )
}

export default Settings
